import { html } from 'htm/preact'
import dayjs from 'dayjs'
import relativeTime from 'dayjs/plugin/relativeTime'

dayjs.extend(relativeTime)

export function NewsCard({ article, source }) {
  const timeAgo = dayjs(article.published_at).fromNow()
  
  const handleClick = () => {
    // Open article in new tab
    window.open(article.url, '_blank', 'noopener,noreferrer')
  }

  return html`
    <article class="news-card cursor-pointer" onClick=${handleClick}>
      <!-- Article Title -->
      <h3 class="news-title mb-3 leading-tight">
        ${article.title}
      </h3>

      <!-- Article Meta -->
      <div class="news-meta">
        ${(source || article.source_name) && html`
          <span class="source-badge">
            ${source?.name || article.source_name}
          </span>
        `}
        
        <span class="flex items-center gap-1">
          <span class="text-gray-400">🕒</span>
          ${timeAgo}
        </span>
      </div>

      <!-- URL Preview -->
      <div class="mt-3 pt-3 border-t border-gray-100 dark:border-gray-700">
        <p class="text-xs text-gray-400 truncate" title=${article.url}>
          ${article.url}
        </p>
      </div>

      <!-- Hover Effect -->
      <div class="absolute inset-0 bg-primary-500 opacity-0 hover:opacity-5 transition-opacity duration-200 rounded-lg pointer-events-none"></div>
    </article>
  `
}